function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'oliven': 'rgb(83, 82, 73)','sort': 'rgb(38, 38, 38)','svart': 'rgb(38, 38, 38)','marinebla': 'rgb(66, 68, 106)','pastellrosa': 'rgb(201, 143, 156)','mintgronn': 'rgb(178, 209, 183)','isbla': 'rgb(218, 226, 227)','grastein': 'rgb(170, 167, 154)','krem': 'rgb(237, 232, 213)','burgunder': 'rgb(115, 64, 86)','himmelbla': 'rgb(166, 190, 217)','mint': 'rgb(128, 199, 190)','lys-gul': 'rgb(244, 224, 140)','gammelrosa': 'rgb(237, 160, 164)','rod': 'rgb(228, 48, 65)','fersken': 'rgb(229, 187, 162)','spicy-orange': 'rgb(226, 112, 89)','gul': 'rgb(244, 203, 76)','lilla': 'rgb(92, 42, 164)','kongebla': 'rgb(21, 64, 117)','eco': 'rgb(254, 243, 217)','bomullsrosa': 'rgb(234, 202, 207)','khaki': 'rgb(88, 86, 77)','cotton-pink': 'rgb(239, 165, 168)','lys-bla': 'rgb(228, 235, 238)','mork-gronn': 'rgb(67, 78, 67)','sand': 'rgb(196, 190, 168)','mocca': 'rgb(99, 91, 82)','mork-bla': 'rgb(64, 71, 123)','naturgronn': 'rgb(111, 126, 120)','fiolett': 'rgb(161, 164, 196)','matt-bla': 'rgb(80, 108, 156)','rosa': 'rgb(244, 77, 133)','gra': 'rgb(235, 234, 234)',};

    this.images = {'lysegra': 'url("//www.educated.no/cdn/shop/files/C146_68x.png?v=18314114284374786553")',};

    this.triggers = ['farge','farger','color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
